// extracted by mini-css-extract-plugin
export default {"virtual":"virtual_virtual__0OOt5","left":"virtual_left__wymZb","wrapper":"virtual_wrapper__3fSf1"};